import { shallowMount } from "@vue/test-utils";
import AppFooter from "@/components/core/AppFooter";

describe("AppFooter test", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(AppFooter);
  });

  it("Render del component AppFooter", () => {
    expect(wrapper).toBeDefined();
  });
});
